import {
    apiRequest,
    orangtuaDetail,
    orangtuaApprove
} from "../../../../../../services/adapters/kepegawaian/orangtuaService"

class DetailRepository {

    fetchDetail = async (query) => {
        return await apiRequest("get", orangtuaDetail, {
            params: query
        }, true)
    }

    fetchApprove = async (query) => {
        return await apiRequest("post", orangtuaApprove, {
            body: query
        }, true)
    }
}

export default DetailRepository